import doFetchTrelloCard from './doFetchTrelloCard'

export default function doFetchTrelloCards(ids) {
  if (!ids) return () => {}
  return dispatch => {
    ids.map(id => dispatch(doFetchTrelloCard(id)))
  }
}
